import { am } from './utils';

import httpClient from '@/utils/httpClient';
import logger from '@/utils/logger';

export const INITIALIZE = am('INITIALIZE');
export const CONFIGURE = am('CONFIGURE');

export const state = {
  isGetRequestPending: false,
  isGetRequestFailed: false,

  isUpdateRequestPending: false,
  isUpdateRequestFailed: false,

  providers: null
};

const getters = {};

export const actions = {
  async initialize({ commit }) {
    commit(INITIALIZE.STARTED);
    try {
      commit(INITIALIZE.COMPLETED, {
        providers: await httpClient.get(`/api/auth/v2`)
      });
    } catch (e) {
      logger.error(e);
      commit(INITIALIZE.FAILED);
      throw e;
    }
  },
  async configure({ commit }, { collection }) {
    commit(CONFIGURE.STARTED);
    try {
      commit(CONFIGURE.COMPLETED, {
        providers: await httpClient.post(`/api/auth/`, collection)
      });
    } catch (e) {
      logger.error(e);
      commit(CONFIGURE.FAILED);
      throw e;
    }
  }
};

export const mutations = {
  [INITIALIZE.STARTED](state) {
    state.isGetRequestPending = true;
    state.isGetRequestFailed = false;
    state.providers = [];
  },
  [INITIALIZE.FAILED](state) {
    state.isGetRequestPending = false;
    state.isGetRequestFailed = true;
  },
  [INITIALIZE.COMPLETED](state, { providers }) {
    state.isGetRequestPending = false;
    state.providers = providers;
  },
  [CONFIGURE.STARTED](state) {
    state.isUpdateRequestPending = true;
    state.isUpdateRequestFailed = false;
  },
  [CONFIGURE.FAILED](state) {
    state.isUpdateRequestPending = false;
    state.isUpdateRequestFailed = true;
  },
  [CONFIGURE.COMPLETED](state, { providers }) {
    state.isUpdateRequestPending = false;
    state.providers = providers;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
